import sickLeaveQuestionComponent from './sickLeaveQuestion.component';

let sickLeaveQuestionModule = angular.module('vacations-absences.sickLeaveQuestion', [])

.component('sickLeaveQuestion', sickLeaveQuestionComponent)

.name;

export default sickLeaveQuestionModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/sickLeaveQuestion/sickLeaveQuestion.js